import { Card, Grid, Icon, IconButton, InputLabel, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDPeriodo from "components/MDPeriodo";
import MDButton from "components/MDButton";
import MDSelect from "components/MDSelect";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { useUser } from "context/UserContext";
import DataTable from "examples/Tables/DataTable";
import { Form, Formik } from "formik";
import DefaultCell from "layouts/dashboards/sales/components/DefaultCell";
import { useCallback, useEffect, useRef, useState } from "react";
import { toDate, toDateReqFormat, toDateTime } from "utils/DateUtils";
import { post } from "utils/WebService";
import LogRoboEditalDetail from "./LogRoboEmailsPushDetail";
import { ESCURO } from "assets/coresTema";


export default function LogRoboEmailsPushConsult() {

    const today = new Date();
    const formattedDate = toDateReqFormat(today, 'yyyy-MM-dd');

    const tableState = useRef({
        pageSize: 10,
        pageIndex: 0,
        sorting: [],
        filtered: [],
        dataInicio: formattedDate,
        dataFim: formattedDate,
        status: null,
    });

    const { roboEditalWibsStatus } = useUser();


    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const [data, setData] = useState([]);
    const [pages, setPages] = useState(0);
    const [loadingTable, setLoadingTable] = useState(true);
    const [isCreateEdit, setIsCreateEdit] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [filters, setFilters] = useState({
        empresa: null,
        status: null
    });

    const [refresh, setRefresh] = useState(false);
    const [recordsTotal, setRecordsTotal] = useState(0);

    useEffect(() => {
        fetchData({ ...tableState });
    }, []);

    const fetchData = useCallback(({ pageSize, pageIndex, sorting, filtered, status, dateInit, dateEnd
    }) => {
        setLoadingTable(true);
        const updatedTableState = {
            pageSize: pageSize ? pageSize : tableState.current.pageSize,
            pageIndex: (pageIndex == 0 || pageIndex) ? pageIndex : tableState.current.pageIndex,
            sorting: sorting ? sorting : tableState.current.sorting,
            filtered: filtered ? filtered : tableState.current.filtered,
            dataInicio: dateInit ? dateInit : tableState.current.dataInicio,
            dataFim: dateEnd ? dateEnd : tableState.current.dataFim,
            status: (status || status?.code == "todos" || status == 0) ? status?.id : tableState.current.status
        };

        tableState.current = updatedTableState;

        post("/robo-emails/list", {
            page: updatedTableState.pageIndex,
            pageSize: updatedTableState.pageSize,
            sorted: updatedTableState.sorting,
            filtered: updatedTableState.filtered,
            dataInicio: updatedTableState.dataInicio,
            dataFim: updatedTableState.dataFim,
            status: updatedTableState.status,
        }).then(({ data, pages, recordsTotal }) => {
            setPages(pages);
            setData(data);
            setRecordsTotal(recordsTotal);
            setLoadingTable(false);
        }).catch(() => setLoadingTable(false));

        setRefresh(false);

    }, [refresh]);

    const backFunction = () => {
        setIsCreateEdit(false);
        setSelectedId(null);
    }

    const handleRefresh = () => {
        setRefresh(true);
    };

    const userColumns = [
        {
            header: "status",
            accessorKey: "roboEditalStatus",
            cell: info => {
                const status = info.getValue();
                const scheduleStatusName = roboEditalWibsStatus?.find(ht => ht.code === status);
                const label = scheduleStatusName ? scheduleStatusName.name : (status === "processed" ? "Concluído" : status === "processing" ? "Processando" : status || "-");
                return <DefaultCell>{label}</DefaultCell>;
            },
            isSorted: false
        },
        {
            header: "processado",
            accessorKey: "processado",
            cell: info => <DefaultCell>{String(info.getValue() || 0)}</DefaultCell>,
            isSorted: true
        },
        {
            header: "erro",
            accessorKey: "erro",
            cell: info => <DefaultCell>{String(info.getValue() || 0)}</DefaultCell>,
            isSorted: true
        },
        {
            header: "data",
            accessorKey: "periodo",
            cell: info => <DefaultCell>{toDate(info.getValue()) || '-'}</DefaultCell>,
            isSorted: true
        },
        {
            header: "ações",
            accessorKey: "id",
            isSorted: false,
            cell: info => (
                <>
                    <Tooltip title="Ver detalhes">
                        <IconButton
                            onClick={() => {
                                setSelectedId(info.getValue());
                                setIsCreateEdit(true);
                            }}>
                            <MDTypography variant="h4">
                                <Icon color="inherit" sx={{ marginRight: 1 }}>visibility</Icon>
                            </MDTypography>
                        </IconButton>
                    </Tooltip>
                </>
            ),
            width: "10%"
        },
    ];

    const handleApplyFilter = (values) => {
        fetchData({
            ...tableState, pageIndex: 0, status: values?.status,
            dateInit: values?.dataInicio, dateEnd: values?.dataFim
        });
    };

    const handleCleanFilter = () => {
        let updatedTableState = {}


        setFilters(prevFilters => ({
            ...prevFilters,
            status: null
        }));

        setData([])
        updatedTableState = {
            pageSize: 10,
            pageIndex: 0,
            sorting: [],
            filtered: [],
            dataInicio: formattedDate,
            dataFim: formattedDate,
            status: null
        };
        tableState.current = updatedTableState;
        fetchData({
            ...tableState
        });

    };

    return (
        <Grid container display="flex" justifyContent="center">

            {isCreateEdit &&
                <Grid item xs={12} md={12}>
                    <LogRoboEditalDetail
                        scheduleId={selectedId}
                        closeCreateEdit={backFunction}
                        refreshTable={handleRefresh} />
                </Grid>
            }
            <Grid item xs={12} md={12} sx={{ display: isCreateEdit ? "none" : "" }}>
                <Card
                    variant="outlined"
                    sx={{
                        px: 2,
                        py: 1.5,
                        mb: 2,
                        background: darkMode ? ESCURO.cartao : "#fafafa",
                        borderColor: darkMode ? ESCURO.divisoria : "#ddd",
                    }}
                >
                    <Formik
                            initialValues={{
                                status: null,
                                dataInicio: formattedDate,
                                dataFim: formattedDate
                            }}
                            onSubmit={(values) => handleApplyFilter(values)}>
                            {({ values, setFieldValue, resetForm }) => (
                                <Form>
                                    <Grid container spacing={1}>
                                            <Grid item xs={12} sm={3}>
                                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Status</InputLabel>
                                                <MDSelect
                                                    isMulti={false}
                                                    getOptionValue={(option) => option.code}
                                                    getOptionLabel={(option) => option.name}
                                                    name="status"
                                                    placeholder="Todos"
                                                    value={values.status || null}
                                                    options={roboEditalWibsStatus}
                                                    onChange={(selectedOption) => {
                                                        setFilters({ ...filters, status: selectedOption?.id })
                                                        setFieldValue("status", selectedOption)
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <MDPeriodo inicio={values.dataInicio} fim={values.dataFim}
                                                    onChange={({ inicio, fim }) => { setFieldValue("dataInicio", inicio); setFieldValue("dataFim", fim); }} />
                                            </Grid>
                                            <Grid item xs={12} textAlign="right" pt={1}>
                                                <MDBox>
                                                    <MDButton
                                                        size="medium"
                                                        sx={{ marginRight: 2 }}
                                                        variant="contained"
                                                        color="info"
                                                        circular={false}
                                                        iconOnly={false}
                                                        onClick={() => {
                                                            resetForm({
                                                                values: {
                                                                    ...values,
                                                                    status: null,
                                                                    dataInicio: formattedDate,
                                                                    dataFim: formattedDate
                                                                },
                                                            });
                                                            handleCleanFilter();
                                                        }}
                                                    >
                                                        Limpar filtro
                                                    </MDButton>
                                                    <MDButton
                                                        size="medium"
                                                        variant="contained"
                                                        color="info"
                                                        circular={false}
                                                        iconOnly={false}
                                                        type="submit"
                                                    >
                                                        Aplicar filtro
                                                    </MDButton>
                                                </MDBox>
                                            </Grid>
                                    </Grid>
                                </Form>
                            )}
                        </Formik>
                </Card>
                <DataTable
                    loading={loadingTable}
                    columnData={userColumns}
                    data={data}
                    fetchData={fetchData}
                    totalPages={pages}
                    totalRecords={recordsTotal}
                    tableState={tableState} />
            </Grid>
        </Grid >
    );
}
